import { useAppDispatch } from "../../../../redux/hooks";
import Text from "../../../../styleguide/Text";
import CustomButton from "../../../../components/CustomButton";

import {
  fetchDeliverySheets,
  generateDeliverySheets,
} from "../../../../redux/api/expedition.api";

import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../helpers/apiHelper";

import useTableCtx from "../../../../components/tables/tableContext/useTableCtx";
import { dateForDatabase } from "../../../../utils/dateAndTime";

function DeliverySheetsTableHeader() {
  const dispatch = useAppDispatch();

  const { tablePagination, tableSearch } = useTableCtx() || {};

  const handleGenerateDeliverySheetsAction = async () => {
    const resultAction = await dispatch(generateDeliverySheets());

    if (
      checkEndpointStatus(resultAction, generateDeliverySheets) ===
      endpointStatus.fulfilled
    ) {
      dispatch(
        fetchDeliverySheets({
          page: tablePagination?.page,
          perPage: tablePagination?.rowsPerPage,
          nod: tableSearch?.nodNume,
          ruta: tableSearch?.ruta,
          data_crearii: dateForDatabase(tableSearch?.data_crearii),
        }),
      );
    }
  };

  return (
    <div className="d-flex justify-content-between mb-6">
      <Text
        variant="h3"
        component="h3"
        className="card-title mb-4"
        style={{ fontWeight: "bolder" }}
        gutterBottom>
        Borderouri de livrare
      </Text>

      <CustomButton
        variant="contained"
        withConfirmationModal={{
          modalTitle: "Genereaza borderouri",
          modalSubtitle:
            "Esti sigur ca vrei sa generezi borderourile pentru ziua curenta?",
          modalLeftButtonText: "Anuleaza",
          modalLeftButtonVariant: "outlined",
          modalRightButtonText: "Genereaza",
          modalRightButtonOnClick: handleGenerateDeliverySheetsAction,
        }}>
        Genereaza borderouri
      </CustomButton>
    </div>
  );
}

export default DeliverySheetsTableHeader;
